export default function PHP_instanceof() {
  return (
    <div>
      <h1>PHP_instanceof</h1>
    </div>
  );
}
